import { Box, Link } from '@chakra-ui/react';
import { onLink } from './index';
import React from 'react';

export const getToday = (hasTime=false) => {
  const today = new Date();
  const shortMonth = today.toLocaleString('default', { month: 'short' });
  const formattedDate = `${shortMonth} ${today.getDate()} ${today.getFullYear()}`;
  if (hasTime) {
    const hours = today.getHours();
    const minutes = today.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedTime = `${hours % 12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    return {date: formattedDate,time: formattedTime};
  }
  return formattedDate;
}
/**
 *
 * @param props
 * @returns {{resume: *, stateProps: *, resumeIndex: *, formikProps: *}}
 */
export const getUsefulVars= (props, index = -1) => {
  const stateProps = props.stateProps;
  const resumeIndex = index === -1 ? stateProps.sectionData.resumeIndex : index;
  const resume = stateProps.dataToSave.saved.resumes ? stateProps.dataToSave.saved.resumes[resumeIndex] : null;
  const formikProps = props.formikProps;
  return { stateProps:stateProps,formikProps: formikProps,resumeIndex:resumeIndex,resume:resume};
}
export const devNull = () => {
  return null;
}
/**
 *
 * @param resume
 * @param sectionName
 * @returns {number|number}
 * @internal This method returns 0 if there are no sections for that resume
 * e.g. They haven't added an award yet.
 */
export const getSectionIndex = (resume,sectionName) => {
  const section = resume[sectionName];
  return  typeof section === 'undefined' ? 0 : section.length - 1;
}

export const getLink = (checkAI = false, formikProps, stateProps, uri, editableIndex = 0, sectionType = 'section', linkName) => {
  return (
    <Box>
    <Link
      onClick={() => onLink(checkAI, formikProps, stateProps, uri, editableIndex, sectionType)}>{linkName}
    </Link>
    </Box>
  );
}
export const setUcfirst = (value) => {
  const newValue = value !== undefined ? value.charAt(0).toUpperCase() + value.slice(1) : '';
  return newValue;
};